// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/account.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BlockAccountRequest, BlockAccountResponse, CreateMagicLinkRequest, CreateMagicLinkResponse, DeleteAccountRequest, DeleteAccountResponse, GetAccountRequest, GetAccountResponse, GetChatIdentityTokenRequest, GetChatIdentityTokenResponse, GetSSOLoginURLRequest, GetSSOLoginURLResponse, ListJoinableOrganizationsRequest, ListJoinableOrganizationsResponse, ListLoginProvidersRequest, ListLoginProvidersResponse, ListSSOLoginsRequest, ListSSOLoginsResponse, UnblockAccountRequest, UnblockAccountResponse } from "./account_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.AccountService
 */
export const AccountService = {
  typeName: "gitpod.v1.AccountService",
  methods: {
    /**
     * Gets information about the currently authenticated account.
     *
     * Use this method to:
     * - Retrieve account profile information
     * - Check organization memberships
     * - View account settings
     * - Get joinable organizations
     *
     * ### Examples
     *
     * - Get account details:
     *
     *   Retrieves information about the authenticated account.
     *
     *   ```yaml
     *   {}
     *   ```
     *
     * @generated from rpc gitpod.v1.AccountService.GetAccount
     */
    getAccount: {
      name: "GetAccount",
      I: GetAccountRequest,
      O: GetAccountResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Deletes an account permanently.
     *
     * Use this method to:
     * - Remove unused accounts
     * - Clean up test accounts
     * - Complete account deletion requests
     *
     * The account must not be an active member of any organization.
     *
     * ### Examples
     *
     * - Delete account:
     *
     *   Permanently removes an account.
     *
     *   ```yaml
     *   accountId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   ```
     *
     * @generated from rpc gitpod.v1.AccountService.DeleteAccount
     */
    deleteAccount: {
      name: "DeleteAccount",
      I: DeleteAccountRequest,
      O: DeleteAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the SSO login URL for a specific email domain.
     *
     * Use this method to:
     * - Initiate SSO authentication
     * - Get organization-specific login URLs
     * - Handle SSO redirects
     *
     * ### Examples
     *
     * - Get login URL:
     *
     *   Retrieves SSO URL for email domain.
     *
     *   ```yaml
     *   email: "user@company.com"
     *   ```
     *
     * - Get URL with return path:
     *
     *   Gets SSO URL with specific return location.
     *
     *   ```yaml
     *   email: "user@company.com"
     *   returnTo: "https://gitpod.io/workspaces"
     *   ```
     *
     * @generated from rpc gitpod.v1.AccountService.GetSSOLoginURL
     */
    getSSOLoginURL: {
      name: "GetSSOLoginURL",
      I: GetSSOLoginURLRequest,
      O: GetSSOLoginURLResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc gitpod.v1.AccountService.ListSSOLogins
     */
    listSSOLogins: {
      name: "ListSSOLogins",
      I: ListSSOLoginsRequest,
      O: ListSSOLoginsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists available login providers with optional filtering.
     *
     * Use this method to:
     * - View supported authentication methods
     * - Get provider-specific login URLs
     * - Filter providers by invite
     *
     * ### Examples
     *
     * - List all providers:
     *
     *   Shows all available login providers.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - List for specific invite:
     *
     *   Shows providers available for an invite.
     *
     *   ```yaml
     *   filter:
     *     inviteId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.AccountService.ListLoginProviders
     */
    listLoginProviders: {
      name: "ListLoginProviders",
      I: ListLoginProvidersRequest,
      O: ListLoginProvidersResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists organizations that the currently authenticated account can join.
     *
     * Use this method to:
     * - Discover organizations associated with the account's email domain.
     * - Allow users to join existing organizations.
     * - Display potential organizations during onboarding.
     *
     * ### Examples
     *
     * - List joinable organizations:
     *
     *   Retrieves a list of organizations the account can join.
     *
     *   ```yaml
     *   {}
     *   ```
     *
     * @generated from rpc gitpod.v1.AccountService.ListJoinableOrganizations
     */
    listJoinableOrganizations: {
      name: "ListJoinableOrganizations",
      I: ListJoinableOrganizationsRequest,
      O: ListJoinableOrganizationsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc gitpod.v1.AccountService.CreateMagicLink
     */
    createMagicLink: {
      name: "CreateMagicLink",
      I: CreateMagicLinkRequest,
      O: CreateMagicLinkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Blocks an account, preventing all API access.
     *
     * Use this method to:
     * - Revoke access for policy violations
     * - Handle abuse cases
     * - Enforce compliance requirements
     *
     * When an account is blocked:
     * - All API requests return 403 PERMISSION_DENIED
     * - All running environments are stopped
     * - All active subscriptions are cancelled
     *
     * Requires the `block_account` permission.
     *
     * ### Examples
     *
     * - Block account for policy violation:
     *
     *   ```yaml
     *   accountId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   reason: "Terms of Service violation - spam"
     *   ```
     *
     * @generated from rpc gitpod.v1.AccountService.BlockAccount
     */
    blockAccount: {
      name: "BlockAccount",
      I: BlockAccountRequest,
      O: BlockAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Unblocks a previously blocked account, restoring API access.
     *
     * Use this method to:
     * - Restore access after resolving policy violations
     * - Reinstate accounts after review
     *
     * Note: Unblocking does NOT restore:
     * - Stopped environments (must be restarted manually)
     * - Cancelled subscriptions (must be re-subscribed)
     * - Deleted resources
     *
     * Requires the `block_account` permission.
     *
     * ### Examples
     *
     * - Unblock account:
     *
     *   ```yaml
     *   accountId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   ```
     *
     * @generated from rpc gitpod.v1.AccountService.UnblockAccount
     */
    unblockAccount: {
      name: "UnblockAccount",
      I: UnblockAccountRequest,
      O: UnblockAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the chat identity token for the currently authenticated account.
     *
     * Use this method to:
     * - Obtain a verification hash for in-app chat identity verification
     * - Secure chat sessions against impersonation
     *
     * The returned hash is an HMAC-SHA256 signature of the account's email,
     * used by the chat widget to verify user identity.
     *
     * ### Examples
     *
     * - Get chat identity token:
     *
     *   Retrieves the identity verification hash for the authenticated account.
     *
     *   ```yaml
     *   {}
     *   ```
     *
     * @generated from rpc gitpod.v1.AccountService.GetChatIdentityToken
     */
    getChatIdentityToken: {
      name: "GetChatIdentityToken",
      I: GetChatIdentityTokenRequest,
      O: GetChatIdentityTokenResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

